import { nanoid } from "nanoid";
import { NodeType } from "../NodeType";

export {
  defaultWaitForCallbackNode,
  WaitForCallbackExpectedFieldType,
  TWaitForCallbackNode,
  TWaitForCallbackNodeConfig,
  TWaitForCallbackNodeConfigExpectedField,
  TWaitForCallbackExpectedFieldType,
};

const defaultWaitForCallbackNode = {
  name: "Wait for Callback",
  description: "",
  callbackId: nanoid(),
  timeoutSeconds: 86400,
  expectedFields: [],
} as const;

type TWaitForCallbackNode = {
  nodeId: string;
  name: string;
  nodeType: typeof NodeType.WAIT_FOR_CALLBACK;
  config: TWaitForCallbackNodeConfig;
};

type TWaitForCallbackNodeConfig = {
  name: string;
  description?: string;
  callbackId: string;
  timeoutSeconds: number;
  expectedFields: Array<TWaitForCallbackNodeConfigExpectedField>;
};

const WaitForCallbackExpectedFieldType = {
  STRING: "string",
  NUMBER: "number",
  BOOLEAN: "boolean",
  OBJECT: "object",
} as const;

type TWaitForCallbackExpectedFieldType =
  (typeof WaitForCallbackExpectedFieldType)[keyof typeof WaitForCallbackExpectedFieldType];

type TWaitForCallbackNodeConfigExpectedField = {
  fieldName: string;
  fieldType: TWaitForCallbackExpectedFieldType;
  isRequired: boolean;
  description?: string;
};
